<template>
  <div>
    <ul class="timeline__messages">
      <li
        v-for="message in messages"
        :key="message.identifier"
        class="timeline__message"
      >
        <component
          :is="message.category"
          :message="message"
        />
      </li>
    </ul>

    <client-only>
      <infinite-loading
        :identifier="infiniteIdentifier"
        @infinite="fetch"
      >
        <div slot="no-results" />
        <div slot="no-more" />
        <div slot="error" slot-scope="{ trigger }">
          Une erreur est survenue.<br>
          Nous en avons été informés.<br>
          <button class="btn-try-infinite" @click.prevent.stop="trigger">
            Réessayer
          </button>
        </div>
      </infinite-loading>
    </client-only>

    <div v-show="hasArchives" class="timeline__archives">
      <div class="timeline__archives__button">
        <ButtonV3
          :loading="archiveButtonLoading"
          :text="archiveButtonText"
          text-uppercase
          :color="paletteFidmarques.yellow"
          bg-color="white"
          :border-color="paletteFidmarques.yellow"
          @click="toggleArchivesAndScroll"
        />
      </div>

      <div v-show="areArchivesOpen" class="timeline__archives__content">
        <ul class="timeline__messages">
          <li
            v-for="message in archivedMessages"
            :key="message.identifier"
            class="timeline__message"
          >
            <component
              :is="message.category"
              :message="message"
              is-archived
            />
          </li>
        </ul>

        <client-only>
          <infinite-loading
            :identifier="archivesInfiniteIdentifier"
            @infinite="fetchArchives"
          >
            <div v-if="!areArchivesLoaded" slot="spinner" />
            <div slot="no-results" />
            <div slot="no-more" />
            <div slot="error" slot-scope="{ trigger }">
              Une erreur est survenue.<br>
              Nous en avons été informés.<br>
              <button class="btn-try-infinite" @click.prevent.stop="trigger">
                Réessayer
              </button>
            </div>
          </infinite-loading>
        </client-only>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import * as MessageTypes from './message-types'

import ButtonV3 from '../../elements/ButtonV3'

import MixinPaletteFidmarques from '~/mixins/paletteFidmarques'

export default {
  components: {
    ...MessageTypes,

    ButtonV3,
  },
  mixins: [MixinPaletteFidmarques],
  props: {
    loaderfixedCentered: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('timeline', [
      'messages',
      'infiniteIdentifier',
      'hasArchives',
      'archivedMessages',
      'archivesInfiniteIdentifier',
      'areArchivesOpen',
      'areArchivesLoaded',
    ]),
    ...mapGetters('timeline', [
      'archiveButtonLoading',
      'archiveButtonText',
    ]),
  },
  created () {
    this.reset()
  },
  methods: {
    ...mapActions('timeline', ['reset', 'fetch', 'toggleArchives', 'fetchArchives']),

    toggleArchivesAndScroll () {
      this.toggleArchives().then(() => {
        this.$nextTick(() => {
          window.scrollBy(0, 50)
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~assets/css/mixins";

.fixed-center {
  @include fixed-center;
}

.section__loader {
  margin: 1rem;
}

.timeline__messages {
  margin: 0;
  padding: 1rem;
  list-style: none;
}
.timeline__message {
  margin-bottom: 1rem;
}

.timeline__archives__button {
  text-align: center;
}
</style>
